import { render, staticRenderFns } from "./PauseTouch.vue?vue&type=template&id=18699c89&scoped=true&"
var script = {}
import style0 from "./PauseTouch.vue?vue&type=style&index=0&id=18699c89&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18699c89",
  null
  
)

export default component.exports